var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from "react";
export var DeleteDialog = function (_a) {
    var alertText = _a.alertText, alertTitle = _a.alertTitle, deleteAction = _a.deleteAction, _b = _a.alertColor, alertColor = _b === void 0 ? 'error' : _b, _c = _a.iconText, iconText = _c === void 0 ? 'Delete' : _c, _d = _a.actionText, actionText = _d === void 0 ? 'Delete' : _d, _e = _a.icon, icon = _e === void 0 ? _jsx(DeleteIcon, {}) : _e;
    var _f = useState(false), isActiveAlert = _f[0], setIsActiveAlert = _f[1];
    var handleClose = function () { return setIsActiveAlert(function (isOpen) { return !isOpen; }); };
    var handleOpen = function () { return setIsActiveAlert(function (isOpen) { return !isOpen; }); };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ onClick: handleOpen, color: alertColor, sx: { textDecoration: "underline", textTransform: "none" }, size: "medium", startIcon: icon }, { children: iconText })), _jsxs(Dialog, __assign({ open: isActiveAlert, onClose: handleClose }, { children: [_jsx(DialogTitle, { children: alertTitle }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: alertText }) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancel" })), _jsx(Button, __assign({ onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, deleteAction()];
                                            case 1:
                                                _a.sent();
                                                handleClose();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, autoFocus: true, color: alertColor }, { children: actionText }))] })] }))] }));
};
